import { mainUrl } from "./apiSettings";

// POST - https://w8d8xqggdi.execute-api.sa-east-1.amazonaws.com/dev/auth
export const LOGIN_POST = `${mainUrl}/auth`;

// POST - https://w8d8xqggdi.execute-api.sa-east-1.amazonaws.com/dev/auth/register
export const REGISTER_POST = `${mainUrl}/auth/register`;



// POST - https://w8d8xqggdi.execute-api.sa-east-1.amazonaws.com/dev/auth/recover
// GET - https://w8d8xqggdi.execute-api.sa-east-1.amazonaws.com/dev/auth/recover/{email}

// GET - https://w8d8xqggdi.execute-api.sa-east-1.amazonaws.com/dev/auth/resend/{email}
// GET - https://w8d8xqggdi.execute-api.sa-east-1.amazonaws.com/dev/auth/version
export const RECOVER_GET_CODE = (email) => `${mainUrl}/auth/recover/${email}`;
export const RECOVER_REDEFINE = `${mainUrl}/auth/recover`;
